import { Theme } from '@mui/material/styles';
import createStyles from '@mui/styles/createStyles';
import makeStyles from '@mui/styles/makeStyles';

import { colorsPalette } from '../../../../theme';

const useStyles = makeStyles((theme: Theme) =>
  createStyles({
    wrapper: {
      display: 'none',
      background: colorsPalette.violetAnalyticsCard,
      padding: '21px 16px',
      borderRadius: 50,
      [theme.breakpoints.up('md')]: {
        display: 'flex',
      },
    },
    listIcon: {
      display: 'block',
      width: 17,
      height: 13,
      cursor: 'pointer',
    },
    gridIcon: {
      display: 'block',
      width: 17,
      height: 14,
      marginLeft: 21,
      cursor: 'pointer',
    },
  }),
);

export default useStyles;
